export const TRIAL_DAYS = 15;

export const PLANES = [
  {
    id: "free",
    name: "Básico",
    precioMensual: 0,
    precioAnual: 0,
    turnosMensuales: 50,
    maxEmpleados: "1",
    maxSucursales: "1",
    soporte: "Email",
    estadisticas: "Básica",
    recordatorios: "Email",
    descripcion: "Para profesionales independientes que están dando sus primeros pasos.",
    features: [
      "1 Profesional",
      "1 Sucursal",
      "50 turnos al mes",
      "Agenda y turnos online 24/7",
      "CRM de clientes con fichas y segmentos",
      "Señas con Mercado Pago",
      "Recordatorios por email",
      "Página pública de reservas",
    ],
    noIncluye: [
      "Más de un profesional",
      "Roles de gerente",
    ],
    destacado: false,
    cta: "Comenzar gratis",
  },
  // TASK-155: plan para el profesional independiente que ya superó el gratuito
  {
    id: "solo",
    name: "Solo",
    precioMensual: 9900,
    precioAnual: 99000,
    turnosMensuales: null,
    maxEmpleados: "1",
    maxSucursales: "1",
    soporte: "Email",
    estadisticas: "Completa",
    recordatorios: "Email",
    descripcion: "Para profesionales independientes con agenda llena.",
    features: [
      "1 Profesional",
      "1 Sucursal",
      "Turnos ilimitados",
      "Todo lo del plan Básico",
      "Estadísticas de facturación y servicios",
    ],
    noIncluye: [
      "Más de un profesional",
      "Roles de gerente",
    ],
    destacado: false,
    cta: "Probar gratis 15 días",
  },
  {
    id: "profesional",
    name: "Profesional",
    precioMensual: 19900,
    precioAnual: 199000,
    turnosMensuales: 2000,
    maxEmpleados: "Hasta 10",
    maxSucursales: "Hasta 3",
    soporte: "Email + Chat",
    estadisticas: "Ocupación y Facturación",
    recordatorios: "Email",
    descripcion: "El preferido por barberías, peluquerías y centros de estética.",
    features: [
      "Hasta 10 Profesionales",
      "Hasta 3 Sucursales",
      "2.000 turnos al mes",
      "Todo lo del plan Solo",
      "Roles de gerente y profesional",
      "Comisiones por profesional",
      "Estadísticas por sucursal y profesional",
    ],
    noIncluye: [],
    destacado: true,
    cta: "Probar gratis 15 días",
  },
  {
    id: "multi",
    name: "Multi-Sucursal",
    precioMensual: 39900,
    precioAnual: 399000,
    turnosMensuales: 5000,
    maxEmpleados: "Ilimitados",
    maxSucursales: "Ilimitadas",
    soporte: "Prioritario (< 2h)",
    estadisticas: "Analítica por sede y global",
    recordatorios: "Email",
    descripcion: "Para cadenas y negocios con múltiples sedes o equipos grandes.",
    features: [
      "Profesionales Ilimitados",
      "Sucursales Ilimitadas",
      "5.000 turnos al mes",
      "Todo lo del plan Profesional",
      "Estadísticas consolidadas de todas las sedes",
      "Soporte VIP Prioritario (< 2h)",
    ],
    noIncluye: [],
    destacado: false,
    cta: "Probar gratis 15 días",
  },
  {
    id: "enterprise",
    name: "Enterprise",
    precioMensual: 79900,
    precioAnual: null,
    turnosMensuales: null,
    maxEmpleados: "Ilimitados",
    maxSucursales: "Ilimitadas",
    soporte: "CSM Dedicado",
    estadisticas: "Reportes a medida",
    recordatorios: "Email",
    isEnterprise: true,
    descripcion: "Para grandes organizaciones con necesidades de personalización y soporte dedicado.",
    features: [
      "Profesionales Ilimitados",
      "Sucursales Ilimitadas",
      "Turnos Ilimitados",
      "Todo lo del plan Multi-Sucursal",
      "Gestor de Cuenta Dedicado (CSM)",
      "Soporte y Onboarding Personalizado",
      "Facturación y Contratos a medida",
    ],
    noIncluye: [],
    destacado: false,
    cta: "Contactar Ventas",
  },
];

export const formatPrecioARS = (value) => {
  if (value === null || value === undefined) return "$0";
  if (typeof value === "number") return `$${value.toLocaleString("es-AR")}`;
  return `$${value}`;
};

export default PLANES;